import { useEffect, useState } from 'react';

/**
 * Subscribes to a media query from JavaScript.
 *
 * Layout belongs in CSS and stays there. This exists for the cases where the breakpoint
 * changes a *prop* rather than a style — Estatísticas is the one: canvas 1o puts its header
 * on green and 1l puts it on white, and the pills inside carry a `tone` that has to follow.
 * Restyling them from the parent is not an option, since CSS Modules hashes their classes.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches);

  useEffect(() => {
    const mql = window.matchMedia(query);
    // Re-read on subscribe: the viewport can change between render and effect.
    setMatches(mql.matches);
    const onChange = (e: MediaQueryListEvent) => setMatches(e.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}

/** The app's one breakpoint, matching the `min-width: 900px` used throughout the CSS. */
export function useIsDesktop(): boolean {
  return useMediaQuery('(min-width: 900px)');
}
